import { Config } from 'tailwindcss';

export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    fontFamily: {
      sans: ['Lato', 'sans-serif'],
      gotham: ['Gotham', 'sans-serif'],
    },
    fontSize: {
      xs: '0.625rem', // 10px
      sm: '0.75rem', // 12px
      md: '1rem', // 16px
      lg: '1.25rem', // 20px
      xl: '1.5rem', // 24px
      '2xl': '2rem', // 32px
    },
    extend: {
      boxShadow: {
        custom: '0px 2px 7px 0px rgba(0, 0, 0, 0.20)',
      },
      backgroundImage: {
        gradient: 'linear-gradient(91deg, #0029E2 0.07%, #00167C 99.16%)',
        'header-border':
          'linear-gradient(90deg,#20C496,#FFFFFF,#FFC800,#8F38B8,#20C496,#FFFFFF,#FFC800,#8F38B8)',
      },
      colors: {
        // Primary
        gray: {
          DEFAULT: '#1F3B52',
          700: '#0B1F30',
          500: '#4C6275',
          400: '#798997',
          300: '#A5B1BA',
          200: '#D2D8DC',
          100: '#F2F3F5',
        },
        blue: {
          DEFAULT: '#0029E2',
          700: '#001D9E',
          500: '#095BFF',
          400: '#6B9DFF',
          300: '#9DBDFF',
          200: '#CEDEFF',
          100: '#E5EAFC',
        },
        orange: {
          DEFAULT: '#FF5F2E',
          700: '#CC4C25',
          500: '#FF8F6D',
          400: '#FFAF96',
          300: '#FFBFAB',
          200: '#FFDFD5',
          100: '#FFEFEA',
        },
        // Secondary
        green: {
          DEFAULT: '#3AB838',
          800: '#298127',
          400: '#9CDB9B',
          200: '#D8F1D7',
        },
        yellow: {
          DEFAULT: '#FFC800',
          800: '#B28C00',
          400: '#FFE380',
          200: '#FFF4CC',
        },
        red: {
          DEFAULT: '#E43600',
          800: '#A02600',
          400: '#F19A80',
          200: '#FAD7CC',
        },
        purple: {
          DEFAULT: '#8F38B8',
          800: '#642781',
          400: '#C79BDB',
          200: '#E9D7F1',
        },
        turquoise: {
          DEFAULT: '#20C496',
          800: '#168969',
          400: '#8FE1CB',
          200: '#D2F3EA',
        },
      },
    },
  },
  plugins: [],
} satisfies Config;
